import React from 'react';
import PropTypes from 'prop-types';

const socialNetworks = ({ twitter, facebook, linkedin, instagram }) => {
  const items = [];
  if (facebook) {
    items.push({
      id: 2,
      name: 'Facebook',
      icon: (
        <svg
          width="16"
          height="19"
          viewBox="0 0 16 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.0789 5.99893H16V0.320804C15.496 0.243429 13.7629 0.0693359 11.7444 0.0693359C7.53271 0.0693359 4.64761 3.02595 4.64761 8.46005V13.4611H0V19.8089H4.64761V35.7808H10.3458V19.8103H14.8054L15.5134 13.4626H10.3445V9.08946C10.3458 7.25478 10.7884 5.99893 13.0789 5.99893Z"
            fill="#F4892F"
          />
        </svg>
      ),
      link: facebook,
    });
  }
  if (twitter) {
    items.push({
      id: 1,
      name: 'Twitter',
      icon: (
        <svg
          width="16"
          height="19"
          viewBox="0 0 32 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32 3.9682C30.81 4.55074 29.542 4.93687 28.22 5.12436C29.58 4.21818 30.618 2.79419 31.106 1.0778C29.838 1.92149 28.438 2.51742 26.946 2.84998C25.742 1.41929 24.026 0.533203 22.154 0.533203C18.522 0.533203 15.598 3.82312 15.598 7.85629C15.598 8.4366 15.642 8.99459 15.75 9.5258C10.296 9.22894 5.47 6.31176 2.228 1.86792C1.662 2.96381 1.33 4.21818 1.33 5.56852C1.33 8.10403 2.5 10.3516 4.244 11.6529C3.19 11.6305 2.156 11.2891 1.28 10.7511C1.28 10.7735 1.28 10.8025 1.28 10.8315C1.28 14.3893 3.554 17.3444 6.536 18.0251C6.002 18.1881 5.42 18.2662 4.816 18.2662C4.396 18.2662 3.972 18.2394 3.574 18.1412C4.424 21.0405 6.836 23.172 9.704 23.2412C7.472 25.1897 4.638 26.3638 1.57 26.3638C1.032 26.3638 0.516 26.337 0 26.2633C2.906 28.3547 6.35 29.5488 10.064 29.5488C22.136 29.5488 28.736 18.3889 28.736 8.71559C28.736 8.39196 28.726 8.07948 28.712 7.76924C30.014 6.73807 31.108 5.45023 32 3.9682Z"
            fill="#F4892F"
          />
        </svg>
      ),
      link: twitter,
    });
  }

  if (instagram) {
    items.push({
      id: 5,
      name: 'Instagram',
      icon: (
        <svg
          width="16"
          height="19"
          viewBox="0 0 33 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24.7504 0H8.25078C3.71379 0 0.000976562 3.71281 0.000976562 8.2498V24.7502C0.000976562 29.286 3.71379 33 8.25078 33H24.7504C29.2874 33 33.0002 29.286 33.0002 24.7502V8.2498C33.0002 3.71281 29.2874 0 24.7504 0ZM30.2501 24.7502C30.2501 27.782 27.7839 30.2499 24.7504 30.2499H8.25078C5.21857 30.2499 2.75104 27.782 2.75104 24.7502V8.2498C2.75104 5.21719 5.21857 2.75007 8.25078 2.75007H24.7504C27.7839 2.75007 30.2501 5.21719 30.2501 8.2498V24.7502Z"
            fill="#F4892F"
          />
          <path
            d="M25.4384 9.62466C26.5775 9.62466 27.5009 8.70127 27.5009 7.56221C27.5009 6.42315 26.5775 5.49976 25.4384 5.49976C24.2994 5.49976 23.376 6.42315 23.376 7.56221C23.376 8.70127 24.2994 9.62466 25.4384 9.62466Z"
            fill="#F4892F"
          />
          <path
            d="M16.4998 8.24976C11.9426 8.24976 8.25 11.9427 8.25 16.4996C8.25 21.0547 11.9426 24.7502 16.4998 24.7502C21.0557 24.7502 24.7496 21.0547 24.7496 16.4996C24.7496 11.9427 21.0557 8.24976 16.4998 8.24976ZM16.4998 22.0001C13.4626 22.0001 11.0001 19.5376 11.0001 16.4996C11.0001 13.4616 13.4626 10.9998 16.4998 10.9998C19.537 10.9998 21.9995 13.4616 21.9995 16.4996C21.9995 19.5376 19.537 22.0001 16.4998 22.0001Z"
            fill="#F4892F"
          />
        </svg>
      ),
      link: instagram,
    });
  }

  if (linkedin) {
    items.push({
      id: 4,
      name: 'linkedin',
      icon: (
        <svg
          width="16"
          height="19"
          viewBox="0 0 32 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_114:1816)">
            <path
              d="M31.992 35.7809V35.7794H32V22.6822C32 16.275 30.764 11.3394 24.052 11.3394C20.8253 11.3394 18.6599 13.3154 17.7759 15.1888H17.6826V11.9375H11.3186V35.7794H17.9453V23.9738C17.9453 20.8654 18.4733 17.8597 21.9226 17.8597C25.3213 17.8597 25.372 21.407 25.372 24.1732V35.7809H31.992Z"
              fill="#F4892F"
            />
            <path
              d="M0.528076 11.939H7.16274V35.7808H0.528076V11.939Z"
              fill="#F4892F"
            />
            <path
              d="M3.84267 0.0693359C1.72133 0.0693359 0 1.99032 0 4.35769C0 6.72506 1.72133 8.68622 3.84267 8.68622C5.964 8.68622 7.68533 6.72506 7.68533 4.35769C7.684 1.99032 5.96267 0.0693359 3.84267 0.0693359V0.0693359Z"
              fill="#F4892F"
            />
          </g>
          <defs>
            <clipPath id="clip0_114:1816">
              <rect
                width="32"
                height="35.7115"
                fill="white"
                transform="translate(0 0.0693359)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
      link: linkedin,
    });
  }
  return items;
};

const SocialIcons = ({ data }) => (
  <div className="is-flex">
    {socialNetworks({
      twitter: data.twitter,
      facebook: data.facebook,
      linkedin: data.linkedin,
      instagram: data.instagram,
    }).map((item) => (
      <a
        key={item.id}
        className="button is-medium mr-4 button is-borderless py-3"
        href={item.link}
        target="_blank"
        rel="noreferrer"
      >
        {item.icon}
      </a>
    ))}
  </div>
);

SocialIcons.defaultProps = {
  data: {},
};

SocialIcons.propTypes = {
  data: PropTypes.object,
};

export default SocialIcons;
